Customer.Conversation ||= {}
Customer.Conversation.Attachments ||= {}

class Customer.Conversation.Attachments.AttachmentVideoPreviewView extends Backbone.View
  template: JST['backbone/templates/customer/conversation/attachments/attachment_video_preview']

  events:
    'click #remove-attachment': 'onClickRemove'

  initialize: (@options = {}) ->
    @attachment = @options.attachment

  render: ->
    @$el.html(@template({ video: @attachment }))
    @

  onClickRemove: (evt) ->
    @trigger('remove-attachment', @attachment)

  attachmentUrl: ->
    @attachment
